import React from "react";
import {
  X,
  Download,
  ExternalLink,
  Calendar,
  FileText,
} from "lucide-react";

const CatalogDownloadsModal = ({
  isOpen,
  onClose,
  catalogs = [],
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[99999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">

      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-hidden">

        {/* Header */}
        <div className="flex items-center justify-between border-b px-6 py-5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white">

          <div>
            <h2 className="text-2xl font-bold !text-white">
              Catalog Downloads
            </h2>

            <p className="text-sm text-white/80">
              Total Products: {catalogs?.length || 0}
            </p>
          </div>

          <button
            onClick={onClose}
            className="p-2 rounded-xl hover:bg-white/20 transition"
          >
            <X size={24} />
          </button>

        </div>

        {/* Body */}
        <div className="overflow-y-auto max-h-[78vh] p-6 bg-gray-50">

          {catalogs?.length > 0 ? (

            <div className="divide-y divide-gray-200">

              {catalogs.map((item, index) => {

                const product = item.product;

                return (
                  <div
                    key={index}
                    className="flex items-center gap-4 p-4 hover:bg-white rounded-xl transition"
                  >

                    {/* Image */}
                    <div className="w-20 h-20 rounded-lg overflow-hidden border bg-white flex-shrink-0">

                      <img
                        src={
                          product?.product_images?.[0]?.variants?.medium ||
                          product?.product_images?.[0]?.p_image ||
                          "/placeholder-product.png"
                        }
                        alt={product?.equip_name}
                        className="w-full h-full object-cover"
                      />

                    </div>

                    {/* Product Info */}
                    <div className="flex-1 min-w-0">

                      <a
                        href={`${process.env.REACT_APP_FRONTEND_URL}/${product?.slug}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-lg font-semibold text-gray-800 hover:text-indigo-600"
                      >
                        {product?.equip_name}
                      </a>

                      <p className="text-sm text-gray-500 mt-1">
                        Brand: {product?.brand || "-"}
                      </p>

                      <div className="flex gap-6 mt-2 text-sm">

                        <span className="text-indigo-600 font-semibold">
                          Downloads Count: {item.download_count}
                        </span>

                        <span className="text-gray-500 flex items-center gap-1">
                          <Calendar size={14} />
                          {new Date(
                            item.last_downloaded_at
                          ).toLocaleString("en-IN")}
                        </span>

                      </div>

                    </div>

                    {/* Actions */}
                    <div className="flex flex-col items-end gap-2">

                     

                      <a
                        href={`${process.env.REACT_APP_FRONTEND_URL}/${product?.slug}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-indigo-600 hover:underline inline-flex items-center gap-1"
                      >
                        View Product
                        <ExternalLink size={14} />
                      </a>

                    </div>

                  </div>
                );
              })}
            </div>

          ) : (

            <div className="py-20 text-center">

              <FileText
                size={70}
                className="mx-auto text-gray-300"
              />

              <h3 className="mt-4 text-lg font-semibold text-gray-600">
                No Catalog Downloads Found
              </h3>

            </div>

          )}

        </div>

      </div>

    </div>
  );
};

export default CatalogDownloadsModal;